import { FragmentType, graphql, useFragment } from '@/generated/gql'
import useTenant from '@/hooks/useTenant'
import { DietaryRow } from '@fusion/dietary/row'
import { CardContent, Stack, Typography } from '@mui/material'

import React from 'react'
import { useTranslation } from 'react-i18next'

const canteenMenuItemIngredientsItemDataFragment = graphql(`
  fragment CanteenMenuItemIngredients_ItemDataFragment on MenuItem {
    _id
    name
    isCombo
    ingredients
    dietaries
    allergens
    subAllergens {
      cereals
      nuts
    }
  }
`)

type Props = {
  itemData: FragmentType<typeof canteenMenuItemIngredientsItemDataFragment>
  companyName: string
}

const MenuItemIngredients: React.FC<Props> = ({ itemData: itemDataProp, companyName }) => {
  const tenant = useTenant()
  const { ingredients, dietaries, allergens, subAllergens, isCombo } = useFragment(
    canteenMenuItemIngredientsItemDataFragment,
    itemDataProp,
  )
  const { t } = useTranslation()
  return (
    <CardContent>
      <Stack spacing={3} direction="column">
        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle3">{t('cc:ingredientList')}</Typography>
          <Typography color="text.secondary" variant="body2">
            ({t('cc:allInformationProvidedBy')} {companyName})
          </Typography>
        </Stack>
        <Typography variant="body1" color="text.secondary">
          {ingredients}
        </Typography>
        <Typography variant="subtitle3">{t('cc:dietaryFlags')}</Typography>
        <DietaryRow showLabel allergens={[]} dietaries={dietaries} />
        <Typography variant="subtitle3">{t('cc:allergens')}</Typography>
        <DietaryRow
          isComboItem={Boolean(isCombo)}
          showLabel
          allergens={allergens}
          subAllergens={subAllergens}
          dietaries={[]}
        />
        <Typography color="text.secondary" variant="body2">
          {t('allergens:info', { tenantName: tenant.name })}.
        </Typography>
      </Stack>
    </CardContent>
  )
}

export default MenuItemIngredients
